import { render, staticRenderFns } from "./SalesButton.vue?vue&type=template&id=20008fff&scoped=true"
import script from "./SalesButton.vue?vue&type=script&lang=js"
export * from "./SalesButton.vue?vue&type=script&lang=js"
import style0 from "./SalesButton.vue?vue&type=style&index=0&id=20008fff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20008fff",
  null
  
)

export default component.exports